import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import * as XLSX from 'xlsx'
import toast from 'react-hot-toast'

export default function ImportTarget({ level, onImport }) {
    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0]

        if (!file) return

        const reader = new FileReader()

        reader.onload = (e) => {
            try {
                // 1. Baca file Excel/CSV
                const data = new Uint8Array(e.target.result)
                const workbook = XLSX.read(data, { type: 'array' })
                
                // 2. Ambil sheet pertama
                const sheetName = workbook.SheetNames[0]
                const worksheet = workbook.Sheets[sheetName]
                
                // 3. Ubah isinya jadi format JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet)

                // 4. Validasi data kosong
                if (jsonData.length === 0) {
                    toast.error("File Excel/CSV kosong!")
                    return
                }

                // 5. Mapping data sesuai kebutuhan state target kamu
                // Pastikan user tau kalau header kolom di Excelnya harus bernama 'id' dan 'name'
                const formattedTargets = jsonData.map((row) => ({
                    id: row.id,
                    name: row.name || `[Imported] ID: ${row.id}`,
                    // Tambahkan atribut lain kalau perlu, misal menyesuaikan 'level'
                })).filter(row => row.id) // Buang baris yang ID-nya kosong

                // 6. Kirim ke parent component
                onImport(formattedTargets)
                toast.success(`${formattedTargets.length} target berhasil di-import!`)
                
            } catch (error) {
                console.error("Error parsing file:", error)
                toast.error("Gagal membaca file. Pastikan formatnya benar.")
            }
        }

        reader.readAsArrayBuffer(file)
    }, [onImport])

    // Konfigurasi Dropzone
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ 
        onDrop,
        accept: {
            'text/csv': ['.csv'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
            'application/vnd.ms-excel': ['.xls']
        },
        maxFiles: 1
    })

    return (
        <div 
            {...getRootProps()} 
            className={`mt-4 flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-xl cursor-pointer transition-colors duration-200 ease-in-out ${
                isDragActive ? 'border-neutral-800 bg-neutral-100' : 'border-neutral-300 hover:border-neutral-400'
            }`}
        >
            <input {...getInputProps()} />
            <div className="space-y-1 text-center">
                <svg className="mx-auto h-12 w-12 text-neutral-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <div className="text-sm text-gray-600">
                    <span className="font-medium text-neutral-900 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-neutral-500">
                        Upload a file
                    </span>
                    <p className="pl-1">atau drag and drop file di sini</p>
                </div>
                <p className="text-xs text-gray-500">CSV atau XLSX up to 10MB</p>
            </div>
        </div>
    )
}